import { render, staticRenderFns } from "./adSeries.vue?vue&type=template&id=05ebddd0&scoped=true"
import script from "./adSeries.vue?vue&type=script&lang=js"
export * from "./adSeries.vue?vue&type=script&lang=js"
import style0 from "./adSeries.vue?vue&type=style&index=0&id=05ebddd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ebddd0",
  null
  
)

export default component.exports